import { WorkerProfile } from "@/components/dashboard-pages/common-dashboard/my-profile/worker-profile";
import { EmployerProfile } from "@/components/dashboard-pages/common-dashboard/my-profile/employer-profile";
import MetaComponent from "@/components/common/MetaComponent";
import { User } from "@/types/userTypes";
import { useSelector } from "react-redux";

const metadata = {
  title: "Mi Perfil | Jandi ",
  description: "Jandi",
};

const MyProfileCandidatesPage = () => {
  const { user: me }: { user: User } = useSelector(
    (state: { user }) => state.user
  );

  return (
    <>
      <MetaComponent meta={metadata} />
      {me.type === "worker" ? <WorkerProfile /> : <EmployerProfile />}
    </>
  );
};

export default MyProfileCandidatesPage;
